export const TASKTYPE_MAP = {
	FIRST_VISIT: '1',
	RESURVEY: '2',
	MOTION: '3',
	LIVING_PLACE: '4',
	WORK_PLACE: '5',
	PURE_MEDIATE: '9',
	OTHER_INVESTIGATE: '15',
	NEW_MOTION: '16',
}

export const tasktypeAuthList = [
	{
		title: '初次探视',
		authStr: 'firstVisit',
		taskType: TASKTYPE_MAP.FIRST_VISIT,
	},
	{
		title: '住院复勘',
		authStr: 'resurvey',
		taskType: TASKTYPE_MAP.RESURVEY,
	},
	{
		title: '活动度复勘',
		authStr: 'motion',
		taskType: TASKTYPE_MAP.MOTION,
	},
	{
		title: '伤者家中调查',
		authStr: 'newMotion',
		taskType: TASKTYPE_MAP.NEW_MOTION,
	},
	{
		title: '居住地真实性调查',
		authStr: 'livingPlace',
		taskType: TASKTYPE_MAP.LIVING_PLACE,
	},
	{
		title: '工作真实性调查',
		authStr: 'workPlace',
		taskType: TASKTYPE_MAP.WORK_PLACE,
	},
	{
		title: '其他调查',
		authStr: 'otherInvestigate',
		taskType: TASKTYPE_MAP.OTHER_INVESTIGATE,
	},
	{
		title: '门诊案件调解',
		authStr: 'outpatientMediate',
		taskType: TASKTYPE_MAP.PURE_MEDIATE,
	},
]

export const insuranceTypeAuthList = [
	{
		title: '车险',
		key: '01',
		authStr: 'addTask:carInsurance',
	},
	{
		title: '责任险',
		key: '02',
		authStr: 'addTask:liabilityInsurance',
	},
	{
		title: '意外险',
		key: '03',
		authStr: 'addTask:accidentInsurance',
	},
	{
		title: '健康险',
		key: '04',
		authStr: 'addTask:healthInsurance',
	},
]
